import React, { useEffect } from "react";
import Layout from "../../components/common/Layout";
import LoginComponent from "../../components/common/user/LoginComponent";
import { Chip, Container, useMediaQuery, useTheme } from "@mui/material";
import PaymentsComponent from "../../components/common/payment/PaymentsComponent";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanelComponent from "../../components/common/TabPanelComponent";
import { getTitle, searchParamToObject } from "../../helpers/SearchParamHelper";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CreditFDocenteteComponent from "../../components/common/payment/CreditFDocenteteComponent";
import { useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import Box from "@mui/material/Box";
import QontoComponent from "../../components/common/payment/QontoComponent";

const AdminPaymentScreen: React.FC = React.memo(() => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const [searchParams, setSearchParams] = useSearchParams();
  const nbErrorPayments = useAppSelector(
    (state: RootState) => state.globalState.nbErrorPayments
  );
  const nbNewQonto = useAppSelector(
    (state: RootState) => state.globalState.nbNewQonto
  );
  const { t } = useTranslation();
  const getValue = React.useCallback(() => {
    const searchParamsObject = searchParamToObject(searchParams);
    return searchParamsObject.tab ? Number(searchParamsObject.tab) : 0;
  }, [searchParams]);
  const [value, setValue] = React.useState(getValue());
  const handleChange = React.useCallback(
    (event: React.SyntheticEvent, newValue: number) => {
      // @ts-ignore
      setSearchParams({
        tab: newValue,
      });
    },
    [setSearchParams]
  );

  useEffect(() => {
    document.title = getTitle("payments");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setValue(getValue());
  }, [searchParams]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Layout>
      <LoginComponent redirect={null} requireAdmin={true}>
        <Tabs
          value={value}
          onChange={handleChange}
          scrollButtons="auto"
          variant={!isSmall ? "standard" : "scrollable"}
          centered={!isSmall}
        >
          <Tab
            label={
              <Box>
                {t("word.payments")}
                {nbErrorPayments !== undefined && nbErrorPayments > 0 && (
                  <Chip
                    label={nbErrorPayments ?? 0}
                    variant="outlined"
                    color="primary"
                    sx={{ marginLeft: 1 }}
                  />
                )}
              </Box>
            }
          />
          <Tab label={t("word.avoirs")} />
          <Tab
            label={
              <Box>
                {t("word.qonto")}
                {nbNewQonto !== undefined && nbNewQonto > 0 && (
                  <Chip
                    label={nbNewQonto ?? 0}
                    variant="outlined"
                    color="primary"
                    sx={{ marginLeft: 1 }}
                  />
                )}
              </Box>
            }
          />
        </Tabs>
        <TabPanelComponent
          sx={{ marginTop: 1 }}
          value={value}
          index={0}
          removeComponentOnHidden={true}
        >
          <Container maxWidth="xl" sx={{ paddingY: 2 }}>
            <PaymentsComponent />
          </Container>
        </TabPanelComponent>
        <TabPanelComponent
          sx={{ marginTop: 1 }}
          value={value}
          index={1}
          removeComponentOnHidden={true}
        >
          <Container maxWidth="xl" sx={{ paddingY: 2 }}>
            <CreditFDocenteteComponent />
          </Container>
        </TabPanelComponent>
        <TabPanelComponent
          sx={{ marginTop: 1 }}
          value={value}
          index={2}
          removeComponentOnHidden={true}
        >
          <Container maxWidth="xl" sx={{ paddingY: 2 }}>
            <QontoComponent />
          </Container>
        </TabPanelComponent>
      </LoginComponent>
    </Layout>
  );
});

export default AdminPaymentScreen;
